import { Button, Stack } from '@components/ui';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTranslation } from 'react-i18next';

import type { HireStepNavigation } from './hireR8trTypes';

interface HireStepActionsProps extends HireStepNavigation {
  primaryLabel?: string;
  onPrimary: () => void;
  primaryDisabled?: boolean;
  loading?: boolean;
}

export const HireStepActions = ({
  primaryLabel,
  onPrimary,
  primaryDisabled = false,
  loading = false,
  onBack,
  onCancel,
}: HireStepActionsProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      gap="md"
      sx={{
        mt: 'auto',
        pt: 2.5,
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      {onBack ? (
        <Button
          variant="secondary"
          onClick={onBack}
          disabled={loading}
          startIcon={<ArrowBackIcon sx={{ fontSize: 18 }} />}
        >
          {t('hire.flow.back')}
        </Button>
      ) : (
        <Button variant="secondary" onClick={onCancel} disabled={loading}>
          {t('hire.flow.cancel')}
        </Button>
      )}
      <Button
        variant="primary"
        sx={{ flex: 1 }}
        onClick={onPrimary}
        disabled={primaryDisabled}
        loading={loading}
      >
        {primaryLabel ?? t('hire.flow.continue')}
      </Button>
    </Stack>
  );
};
